import { configureStore } from '@reduxjs/toolkit'
import menuSlice from './menuslice';
import magneticslice from './magneticslice';
import itsoslice from './itsoslice';
import settingsSlice  from './settingsslice';
import authSlice from './authslice';
import notificationslice from './notificationslice';
import commonslice from './commonslice';
import UpdatePassDialogSlice from './updatepasswordslice';
import EnvSettingDialogSlice from './envsettingdialogslice';
import jobsslice from './jobsslice';
import  reportsSlice  from './reportslice';
export const store = configureStore({
  reducer: {
    menuReducer:menuSlice,
    magneticReducer:magneticslice,
    itsoReducer:itsoslice,
    settingsReducer:settingsSlice,
    authReducer:authSlice,
    notificationReducer:notificationslice,
    commonReducer:commonslice,
    updatePassdialogReducer:UpdatePassDialogSlice,
    jobsSliceReducer:jobsslice,
    envSettingDialogReducer:EnvSettingDialogSlice,
    reportsReducer:reportsSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch